const translations = {
  'zh-CN': {
    // Sidebar
    home: '首页',
    search: '搜索',
    categories: '分类',
    more: '更多',
    toolbox: '工具箱',
    contact: '联系我们',
    about: '关于',
    pinSidebar: '固定侧边栏',
    unpinSidebar: '取消固定',

    // Home hero
    heroTitle1: '发现',
    heroTitle2: '工具与资源',
    resources: '资源',
    categoryCount: '分类',

    // Search
    searchPlaceholder: '搜索工具和资源...',
    searchResults: '搜索结果',
    resultsFor: '的搜索结果',
    clearSearch: '清除搜索',
    noResults: '未找到资源',
    noResultsHint: '请尝试调整搜索关键词。',

    // Category sections
    all: '全部',
    noResourcesInSubcat: '此子分类暂无资源',

    // Cards
    details: '详情',
    visit: '访问',

    // Resource detail
    backToHome: '返回首页',
    allTools: '所有工具',
    aboutSite: '关于',
    tags: '标签',
    websiteInfo: '网站信息',
    domain: '域名',
    category: '分类',
    views: '浏览量',
    added: '添加时间',
    relatedResources: '相关资源',
    resourceNotFound: '资源未找到',
    visitSite: '访问',

    // Footer banner
    footerTitle: '想在这里列出您的工具？',
    footerDesc: '提交您的资源，让数千名用户发现最好的工具。',
    footerBtn: '提交资源',

    // Tools page
    toolsTitle: '工具箱',
    toolsDesc: '免费在线工具，助力营销与开发',
    back: '返回',
    utmName: 'UTM链接生成器',
    utmDesc: '使用UTM参数构建活动跟踪URL',
    qrName: '二维码生成器',
    qrDesc: '为任何文本或URL生成二维码',
    currencyName: '货币换算',
    currencyDesc: '20+种货币实时汇率换算',
    passwordName: '密码生成器',
    passwordDesc: '生成安全随机密码，自定义规则',
    base64Name: 'Base64编码/解码',
    base64Desc: '编码或解码Base64字符串',
    metaName: 'SEO Meta标签生成器',
    metaDesc: '生成Open Graph和Twitter Card元标签',
    generate: '生成',
    convert: '转换',
    converting: '换算中...',
    encode: '编码',
    decode: '解码',
    download: '下载',
    copy: '复制',
    from: '从',
    to: '到',
    amount: '金额',
    size: '大小',
    length: '长度',
    uppercase: '大写字母 (A-Z)',
    lowercase: '小写字母 (a-z)',
    numbers: '数字 (0-9)',
    symbols: '符号 (!@#$)',
    weak: '弱',
    fair: '一般',
    strong: '强',
    veryStrong: '非常强',
    generatedUrl: '生成的URL',
    textOrUrl: '文本或URL',
    websiteUrl: '网站URL',
    source: '来源',
    medium: '媒介',
    campaign: '活动',
    term: '关键词（可选）',
    content: '内容（可选）',
    pageTitle: '页面标题',
    description: '描述',
    keywords: '关键词（逗号分隔）',
    pageUrl: '页面URL',
    ogImage: 'OG图片URL',
    result: '结果',
    generatedMeta: '生成的Meta标签',
    plainText: '纯文本',
    base64String: 'Base64字符串',
    enterTextEncode: '输入要编码的文本...',
    enterBase64Decode: '输入要解码的Base64...',
    enterTextQr: '输入文本或URL以生成二维码...',
    downloadPng: '下载PNG',
    rate: '汇率',

    // Theme
    light: '浅色',
    dark: '深色',
    auto: '自动',

    // Google Login
    loginTitle: '欢迎来到 GGLANCC',
    loginDesc: '登录即可收藏资源、获取个性化推荐',
    loginSkip: '暂时跳过',
    welcomeBack: '欢迎回来',
    logout: '退出登录',

    // Misc
    prev: '上一页',
    next: '下一页',
    uncategorized: '未分类',
    na: '暂无',
  },
  en: {
    home: 'Home',
    search: 'Search',
    categories: 'Categories',
    more: 'More',
    toolbox: 'Toolbox',
    contact: 'Contact',
    about: 'About',
    pinSidebar: 'Pin sidebar open',
    unpinSidebar: 'Unpin sidebar',

    heroTitle1: 'Discover',
    heroTitle2: 'Tools & Resources',
    resources: 'Resources',
    categoryCount: 'Categories',

    searchPlaceholder: 'Search tools and resources...',
    searchResults: 'Search Results',
    resultsFor: 'Results for',
    clearSearch: 'Clear search',
    noResults: 'No resources found',
    noResultsHint: 'Try adjusting your search terms.',

    all: 'All',
    noResourcesInSubcat: 'No resources in this subcategory',

    details: 'Details',
    visit: 'Visit',

    backToHome: 'Back to Home',
    allTools: 'All Tools',
    aboutSite: 'About',
    tags: 'Tags',
    websiteInfo: 'Website Information',
    domain: 'Domain',
    category: 'Category',
    views: 'views',
    added: 'Added',
    relatedResources: 'Related Resources',
    resourceNotFound: 'Resource not found',
    visitSite: 'Visit',

    footerTitle: 'Want to list your tool here?',
    footerDesc: 'Submit your resource and reach thousands of users looking for the best tools.',
    footerBtn: 'Submit a Resource',

    toolsTitle: 'Toolbox',
    toolsDesc: 'Free online tools for marketers & developers',
    back: 'Back',
    utmName: 'UTM Link Builder',
    utmDesc: 'Build campaign tracking URLs with UTM parameters',
    qrName: 'QR Code Generator',
    qrDesc: 'Generate QR codes for any text or URL',
    currencyName: 'Currency Converter',
    currencyDesc: 'Convert between 20+ currencies with live rates',
    passwordName: 'Password Generator',
    passwordDesc: 'Generate secure random passwords with custom rules',
    base64Name: 'Base64 Encoder / Decoder',
    base64Desc: 'Encode or decode Base64 strings',
    metaName: 'SEO Meta Tag Generator',
    metaDesc: 'Generate meta tags with Open Graph & Twitter Card',
    generate: 'Generate',
    convert: 'Convert',
    converting: 'Converting...',
    encode: 'Encode',
    decode: 'Decode',
    download: 'Download',
    copy: 'Copy',
    from: 'From',
    to: 'To',
    amount: 'Amount',
    size: 'Size',
    length: 'Length',
    uppercase: 'Uppercase (A-Z)',
    lowercase: 'Lowercase (a-z)',
    numbers: 'Numbers (0-9)',
    symbols: 'Symbols (!@#$)',
    weak: 'Weak',
    fair: 'Fair',
    strong: 'Strong',
    veryStrong: 'Very Strong',
    generatedUrl: 'Generated URL',
    textOrUrl: 'Text or URL',
    websiteUrl: 'Website URL',
    source: 'Source',
    medium: 'Medium',
    campaign: 'Campaign',
    term: 'Term (optional)',
    content: 'Content (optional)',
    pageTitle: 'Page Title',
    description: 'Description',
    keywords: 'Keywords (comma-separated)',
    pageUrl: 'Page URL',
    ogImage: 'OG Image URL',
    result: 'Result',
    generatedMeta: 'Generated Meta Tags',
    plainText: 'Plain Text',
    base64String: 'Base64 String',
    enterTextEncode: 'Enter text to encode...',
    enterBase64Decode: 'Enter Base64 to decode...',
    enterTextQr: 'Enter text or URL to encode...',
    downloadPng: 'Download PNG',
    rate: 'Rate',

    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',

    loginTitle: 'Welcome to GGLANCC',
    loginDesc: 'Sign in to bookmark resources and get personalized recommendations',
    loginSkip: 'Skip for now',
    welcomeBack: 'Welcome back',
    logout: 'Sign out',

    prev: 'Prev',
    next: 'Next',
    uncategorized: 'Uncategorized',
    na: 'N/A',
  }
};

export function t(lang, key) {
  const langKey = lang === 'en' ? 'en' : 'zh-CN';
  return (translations[langKey] && translations[langKey][key]) || translations['en'][key] || key;
}
